import React from "react";
import {connect} from "react-redux";
import "./DownloadManager.css";
import Hash from "object-hash";
import {IconContainer, TableData, TableRow} from "../../../ResultTable/Components/ResultRow/StyledResultRow";
import DocumentDownload from "../../../../../Download/Entity/DocumentDownload";
import {DownloadState} from "../../../../../Download/Reducer/Download";
import DownloadManagerColumnAction from "./DownloadManagerColumnAction";
import FeatherIconWrapper from "../../../Icons/FeatherIconWrapper";
import {WerfenColor} from "../../../../Constants/ColorChart";
import ResourceIcon from "../../../Icons/Resource/Resource";

type DownloadManagerRowProps = {
    document: DocumentDownload;
    index: number;
}

const DownloadManagerRow = (props: DownloadManagerRowProps & mapStateToPropsType) => {
    const {document, index, documents} = props;
    const rowId: string = Hash(document);
    const tableRowClassName: string = (index % 2 === 0 ? "even" : "odd") + " download-manager-row";

    return (
        <TableRow id={rowId} className={tableRowClassName}>
            <TableData key="type" width={"30"}>
                <IconContainer className={"iconContainer"} data-title={"Type"}>
                    <FeatherIconWrapper
                        color={WerfenColor}
                        fillColor={"none"}
                        width={"30px"}
                        iconStyle={{margin: "0px"}}
                        fillSecondaryColor={null}
                        onClick={(event: Event): void => {
                        }}
                        isActive={true}
                        className={null}
                        ariaLabel={"Type"}
                        role={null}
                        Icon={ResourceIcon}/>
                </IconContainer>
            </TableData>
            <TableData key="name" width={"*"}>
                {document.getName()}
            </TableData>
            <TableData key="status" width={"*"}>
                {document.getStatus()}
            </TableData>
            <DownloadManagerColumnAction document={document} documents={documents}/>
        </TableRow>
    );
}

type DownloadManagerRowStageProps = {
    download: DownloadState
}

type mapStateToPropsType = {
    documents: DocumentDownload[]
}

const mapStateToProps = (state: DownloadManagerRowStageProps): mapStateToPropsType => (
    {
        documents: state.download.download
    }
);

export default connect(mapStateToProps, {})(DownloadManagerRow);
